// Puerto verbatim de packages/hce/src/hce/forms/vitalSigns.ts.
export interface DefinicionSignoVital {
  clave: string;
  etiqueta: string;
  loinc: string;
  unidad: string;
  unidadUcum: string;
}

export const SIGNOS_VITALES: DefinicionSignoVital[] = [
  { clave: 'temperatura', etiqueta: 'Temperatura', loinc: '8310-5', unidad: '°C', unidadUcum: 'Cel' },
  { clave: 'fc', etiqueta: 'Frecuencia cardíaca', loinc: '8867-4', unidad: 'lpm', unidadUcum: '/min' },
  { clave: 'fr', etiqueta: 'Frecuencia respiratoria', loinc: '9279-1', unidad: 'rpm', unidadUcum: '/min' },
  { clave: 'sato2', etiqueta: 'Saturación de oxígeno', loinc: '59408-5', unidad: '%', unidadUcum: '%' },
  { clave: 'peso', etiqueta: 'Peso', loinc: '29463-7', unidad: 'kg', unidadUcum: 'kg' },
  { clave: 'talla', etiqueta: 'Talla', loinc: '8302-2', unidad: 'cm', unidadUcum: 'cm' },
];

export const PA_SISTOLICA_LOINC = '8480-6';
export const PA_DIASTOLICA_LOINC = '8462-4';
export const PA_PANEL_LOINC = '85354-9';
